module.exports = __webpack_public_path__ + "static/media/drupal-original.9b9e5a07.svg";